import { Injectable } from '@angular/core';

import { Actions } from '@ngrx/effects';

@Injectable()
export class MerchantEffects {
  constructor(
    private actions$: Actions
  ) {}
}


